import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Page2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  const userInput = location.state.userInput;
  const userKey = location.state.hexInput;
  let hexkey = userKey;
  let hexuserInput = userInput;
  const allEncResults = location.state.allEncResults;
  console.log("allEncResults", allEncResults);


  const firstpage = () => {
    navigate("/initial", { state: { hexkey, hexuserInput } });
  };

  const secondpage = () => {
    navigate("/round", { state: { allResults, allEncResults, userInput, userKey, cols } });
  };

  const icon = {
    hidden: {
      x: -700,
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1,
      },
    },
  };

  let data = allEncResults[0][0].toString().split(" ");
  console.log("data", data);

  let cols = [
    [data.slice(0, 4)],
    [data.slice(4, 8)],
    [data.slice(8, 12)],
    [data.slice(12, 16)],
  ];

  console.log(cols)

  const renderTable = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">
              {cols[j][0][i]}
            </div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  return (
    <>
      <div class="fixed top-16 right-8 h-2/5 w-1/6 rounded-xl bg-emerald-100 shadow p-4 mt-44">
        <div class="text-center">
          <h2 className="text-xl pb-10 pt-4 font-semibold">
            How intial transformation is performed 
          </h2>
          <p class="text-sm">
            Perform Xor between the plain text and round 1 key
            <br />
            <br />
            The result is written column wise as initial transformation.
          </p>
        </div>
      </div>
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h2 className=" font-semibold text-2xl">Round 1</h2>
            <h2 className=" font-semibold text-xl">Step 0</h2>
            <div className="grid grid-flow-col grid-cols-3 justify-center align-middle gap-2 pt-28">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className=" bg-emerald-100 rounded-xl p-6 align-middle"
              >
                <p className=" bg-emerald-200 mt-8">{userInput}</p>
                <p>XOR</p>
                <p className=" bg-emerald-200">{userKey}</p>
                <p>=</p>
                <p className=" bg-emerald-200">{allEncResults[0][0]}</p>
              </motion.div>
              <div className=" pt-20 pl-7">
                <svg
                  width="300"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
              </div>
              <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 2 }}
              className="w-fit">
              <table className=" bg-emerald-100 rounded-xl w-auto">
        <tbody className="">
          {renderTable()}
        </tbody>
      </table>
      <p className="align-middle"> Initial transformation</p>

              </motion.div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={secondpage}>
          NEXT
        </div>
      </div>
    </>
  );
};

export default Page2;
